import React, { useEffect } from "react";
import { NavLink } from "react-router-dom";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import IconButton from "@material-ui/core/IconButton";
import TextField from "@material-ui/core/TextField";
import Tooltip from "@material-ui/core/Tooltip";
import PeopleIcon from "@material-ui/icons/People";
import PersonAddIcon from "@material-ui/icons/PersonAdd";
import useReducerOnChange from "../../hooks/ReducerOnChange";
import * as Glob from "../../Globale";
import * as Dati from "../../Dati";
import { Trad } from "../../components/";
import { _MainContent, _PageTitle, _PageWrapper } from "../../inar2/layout";
import { _Button, _UsersListTable } from "../../inar2/components";
import useTable from "../../inar2/hooks/Table";

export const _UsersList: React.FC<Glob.IRouteGlobaleProps> = props => {
    const [FormData, setFormData] = useReducerOnChange<Dati.TListaParametri>({ ID_Utente: "", Nome: "", Cognome: "", Login: "", Email: "" });
    const { Data, Options, IsLoading } = useTable("/api/Utenti/Ricerca", FormData);

    useEffect(() => {
        if (!Glob.AzioneAbilitata("UtentiController", Glob.Lettura)) {
            location.replace("/ErroreAccesso");
            return;
        }

        props.SetMenu({ ...Glob.GetMenu(), Main: "Utente", ID_MenuMain: 32 });
    }, []);

    return (
        <_PageWrapper {...props}>
            <Container component="main" maxWidth="lg">
                <_PageTitle Icon={PeopleIcon} Title="Utente">
                    {Glob.AzioneAbilitata("UtentiController", Glob.Scrittura) && (
                        <NavLink to="/Utente/0">
                            <Tooltip title={Trad.Trad("Nuovo")}>
                                <IconButton size="small" aria-label="add">
                                    <PersonAddIcon color="action" />
                                </IconButton>
                            </Tooltip>
                        </NavLink>
                    )}
                </_PageTitle>
                <_MainContent>
                    <form noValidate autoComplete="off">
                        <Grid container spacing={4}>
                            <Grid item xs={6} md={2}>
                                <TextField
                                    fullWidth
                                    id="ID_Utente"
                                    label={Trad.Trad("ID")}
                                    value={FormData.ID_Utente}
                                    onChange={e => setFormData({ Type: "OnChangeFromForm", Target: e.currentTarget })}
                                />
                            </Grid>
                            <Grid item xs={6} md={2}>
                                <TextField fullWidth id="Nome" label={Trad.Trad("Nome")} value={FormData.Nome} onChange={e => setFormData({ Type: "OnChangeFromForm", Target: e.currentTarget })} />
                            </Grid>
                            <Grid item xs={6} md={2}>
                                <TextField
                                    fullWidth
                                    id="Cognome"
                                    label={Trad.Trad("Cognome")}
                                    value={FormData.Cognome}
                                    onChange={e => setFormData({ Type: "OnChangeFromForm", Target: e.currentTarget })}
                                />
                            </Grid>
                            <Grid item xs={6} md={2}>
                                <TextField fullWidth id="Login" label={Trad.Trad("Login")} value={FormData.Login} onChange={e => setFormData({ Type: "OnChangeFromForm", Target: e.currentTarget })} />
                            </Grid>
                            <Grid item xs={6} md={2}>
                                <TextField fullWidth id="Email" label={Trad.Trad("Email")} value={FormData.Email} onChange={e => setFormData({ Type: "OnChangeFromForm", Target: e.currentTarget })} />
                            </Grid>
                        </Grid>
                        <Grid>
                            <Grid item md={1}>
                                <_Button
                                    Attivo={!IsLoading}
                                    Testo={Trad.Trad("Cerca")}
                                    OnClick={() => {
                                        Options.onChangePage(0);
                                    }}
                                />
                            </Grid>
                        </Grid>
                    </form>
                    <_UsersListTable Data={Data} IsLoading={IsLoading} Options={Options} />
                </_MainContent>
            </Container>
        </_PageWrapper>
    );
};



// WEBPACK FOOTER //
// ./src/inar2/pages/UsersList.tsx